module.exports = __webpack_public_path__ + "static/img/back-ico.999ec36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/back-ico.png
// module id = rRck
// module chunks = 0